module.exports = __webpack_public_path__ + "media/slide4-click-action.2e1e7b77.mp4";